import { render, staticRenderFns } from "./TaskType.vue?vue&type=template&id=65954819&scoped=true"
import script from "./TaskType.vue?vue&type=script&lang=js"
export * from "./TaskType.vue?vue&type=script&lang=js"
import style0 from "./TaskType.vue?vue&type=style&index=0&id=65954819&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65954819",
  null
  
)

export default component.exports